<template>
  <sticky-header-layout>
    <!-- Header -->
    <template #header>
      <div class="action-container justify-content-end">
        <div class="button-container">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >{{ $t('button.create') }}</el-button>
        </div>
      </div>
    </template>
    <!-- Header -->

    <div>
      <!-- Store Selector -->
      <div class="store-selector mt-3">
        {{ $t('promoCode.selectStore') }}:
        <store-selector
          :store.sync="storeQuery"
          class="w-100"
          @change="handleSelectedStoreChange"
          @search="handleStoreResult"
        />
      </div>
      <!-- Store Selector -->

      <template v-if="storeQuery">
        <h5>{{ $t('promoCode.promotionCodes') }}:</h5>
        <el-tabs
          v-model="activeTab"
          type="card"
        >
          <el-tab-pane
            label="Enabled"
            name="enabled"
          >
            <promo-code-list-table
              :is-loading="isLoading"
              :data="enabledPromoCodeList"
              @edit="handleEdit"
            />
          </el-tab-pane>
          <el-tab-pane
            label="Disabled"
            name="disabled"
          >
            <promo-code-list-table
              :is-loading="isLoading"
              :data="disabledPromoCodeList"
              @edit="handleEdit"
            />
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
  </sticky-header-layout>
</template>

<script>
import PromoCodeListTable from './components/PromoCodeListTable.vue'
import StoreSelector from '../../components/StoreSelector.vue'

import PromoCodeService from '../../api/promo-code'
import { transformPromoCodeData } from '../../const/promo-tag'

export default {
  name: 'PromoCodeList',
  components: {
    PromoCodeListTable,
    StoreSelector,
  },
  props: {
    store: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      list: [],
      stores: [],
      storeQuery: null,
      selectedStoreId: null,
      activeTab: 'enabled',
    }
  },
  computed: {
    enabledPromoCodeList() {
      return this.list.filter(item => item.enabled)
    },
    disabledPromoCodeList() {
      return this.list.filter(item => !item.enabled)
    },
  },
  mounted() {
    if (this.store) {
      this.preselectStore(this.store)
    }
  },
  methods: {
    async getPromoCodes({ storeId }) {
      this.isLoading = true
      this.selectedStoreId = storeId
      try {
        const { data } = await PromoCodeService.getByStore(storeId)
        this.list = (data || []).map(transformPromoCodeData)
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false
      }
    },
    preselectStore(store) {
      this.storeQuery = store.name
      this.selectedStoreId = store.id
      this.stores = [store]
      this.getPromoCodes({ storeId: store.id })
    },
    handleCreate() {
      this.$router.push({ name: 'PromotionCodeCreate' })
    },
    handleSelectedStoreChange(storeId) {
      this.getPromoCodes({ storeId })
    },
    handleStoreResult({ result }) {
      this.stores = result
    },
    handleEdit(promoCodeId) {
      const store = this.stores.find(s => s.id === this.selectedStoreId)
      const params = { store, id: promoCodeId }
      this.$router.push({ name: 'PromotionCodeDetail', params })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";

.store-selector {
  font-size: 14px;
}

.el-select {
  min-width: 240px;
}
</style>
